import { IStorageAdapter } from "../IStorageAdapter";
import LocalStorageAdapter from "../LocalStorageAdapter/LocalStorageAdapter";

export default class StorageService {
  private adapter: IStorageAdapter;

  constructor(adapter: IStorageAdapter) {
    this.adapter = adapter;
  }

  public getItem(key: string): string | null {
    return this.adapter.getItem(key);
  }

  public setItem(key: string, value: string): void {
    this.adapter.setItem(key, value);
  }

  public removeItem(key: string): void {
    this.adapter.removeItem(key);
  }

  public clear(): void {
    this.adapter.clear();
  }
}

export const LocalStorageService = new StorageService(
  new LocalStorageAdapter()
);
